import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../common/components/Button";
import { StyledH2 } from "../../../common/components/Title/styles";
import { getServiceProviderSchedulesById } from "../../../api/serviceProviderApi";
import AddServiceProviderScheduleDialog from "./AddServiceProviderScheduleDialog";
import { getTime } from "../../../common/helpers/normalizeDateTime";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ConfirmationDialog from "../../../common/components/Dialog";
import { deleteServiceProviderSchedule } from "../../../api/scheduleApi";
const ServiceProviderScheduleTable = ({ serviceProviderData, theme }) => {
  const [schedules, setSchedules] = useState([]);
  const [openAddSchedule, setOpenAddSchedule] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  const handleCloseAddSchedule = () => {
    setOpenAddSchedule(false);
  };

  const fetchServiceProviderSchedules = async () => {
    const response = await getServiceProviderSchedulesById(
      serviceProviderData.id
    );
    setSchedules(response);
  };

  useEffect(() => {
    fetchServiceProviderSchedules();
  }, []);

  const handleDeleteSchedule = async (params) => {
    const request = {
      serviceProviderId: serviceProviderData.id,
      day: params.row.day,
      startTime: params.row.startTime,
      endTime: params.row.endTime,
    };
    await deleteServiceProviderSchedule(request);
    await fetchServiceProviderSchedules();
  };

  const columns = [
    { field: "day", headerName: "Day", flex: 1 },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 1,
      valueFormatter: (params) =>
        params?.value !== null ? getTime(params?.value) : "",
    },
    {
      field: "endTime",
      headerName: "End Time",
      flex: 1,
      valueFormatter: (params) =>
        params?.value !== null ? getTime(params?.value) : "",
    },

    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return (
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              setShowConfirmationDialog(true);
              setConfirmationSubmit(() => () => {
                handleDeleteSchedule(params);
                setShowConfirmationDialog(false);
              });
            }}
          />
        );
      },
    },
  ];

  return (
    <div>
      <AddServiceProviderScheduleDialog
        openAddSchedule={openAddSchedule}
        handleCloseAddSchedule={handleCloseAddSchedule}
        currentServiceProvider={serviceProviderData}
        fetchServiceProviderSchedules={fetchServiceProviderSchedules}
      />
      <StyledH2 theme="purple">Service Provider Schedule</StyledH2>
      <StyledButton onClick={setOpenAddSchedule} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add service provider schedule
      </StyledButton>
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete selected schedule?"}
      />
      <StyledDataGrid autoHeight rows={schedules} columns={columns} />
    </div>
  );
};

export default ServiceProviderScheduleTable;
